import { Injectable } from '@angular/core';
import { catchError, map, tap } from 'rxjs/operators';
import { HttpClient, HttpHeaders, HttpEvent } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/do';
import 'rxjs/add/observable/of';
import { User, BackendUserModel } from '../model/user';
import { of } from 'rxjs/observable/of';
import { HttpErrorResponse } from '@angular/common/http/src/response';
import { environment } from '../../environments/environment';
//PARSE
import 'parse';
const parse: typeof Parse = require('parse');
import { ParseService } from "./parse.service";
import { AuthService } from "./auth.service";
import { LocalstorageService } from './localstorage.service';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
};

@Injectable()
export class UserService {
  private token: string;
  private baseUrl =
    environment.baseURL + ':' + environment.portAPI + '/api/company/signin';
  users: User[] = [];

  constructor(
    public auth: AuthService,
    private _http: HttpClient,
    private _router: Router,
    private _localStorageService: LocalstorageService
  ) {
    var currentUser = JSON.parse(this._localStorageService.getItem('currentUser'));
    this.token = currentUser && currentUser.token;
  }

  getUsers(): Observable<User[]> {
    return this._http.get<User[]>(this.baseUrl).pipe(
      tap(users => this.log(`fetched users`)),
      catchError(this.handleError('getUsers', []))
    );
  }
  //
  // getUser(user: User): Observable<User> {
  //   const url = `${this.baseUrl}/?username=${user.username}&password=${
  //     user.password
  //   }`;
  //   return this._http
  //     .get<User>(url)
  //     .pipe(
  //       tap(_ => this.log(`fetched user username=${user.username}`)),
  //       catchError(this.handleError<User>(`getUser username=${user.username}`))
  //     );
  // }

  signin(user): Observable<BackendUserModel> {
    var backendUserModel = new BackendUserModel(
      null,
      user.username,
      user.password,
      null
    );
    return this._http
      .post<BackendUserModel>(this.baseUrl, backendUserModel, httpOptions)
      .pipe(
        tap((response: any) => {
          this.token = response.token;
          this._localStorageService.setItem(
            'currentUser',
            JSON.stringify({ token: this.token })
          );
          this.log(
            `requesting backendUserModel id=${backendUserModel.identifier}`
          );
        }),
        catchError(this.handleError<BackendUserModel>('signin'))
      );
    /*
    if (user.username === "olympiclocation" && user.password === "1234") {
      this.token = "" + Math.floor(Math.random() * 134632187) + 1;
      // store username and jwt token in local storage to keep user logged in between page refreshes
      localStorage.setItem('currentUser', JSON.stringify({ username: user.username, token: this.token }));
      return true;
    } else {
      return false;
    }
    */
  }

  saveLocalStorage(username, userId): boolean {
    this.token = '' + Math.floor(Math.random() * 134632187) + 1;
    // store username and jwt token in local storage to keep user logged in between page refreshes
    this._localStorageService.setItem(
      'currentUser',
      JSON.stringify({ username: username, userId: userId, token: this.token })
    );
    if (this.isLoggedIn()) {
      return true;
    } else {
      return false;
    }
  }

  signout(): void {
    // clear token remove user from local storage to log user out
    this.token = null;
    this._localStorageService.removeItem('currentUser');
    this._router.navigate(['/user/signin']);
  }

  isLoggedIn(): boolean {
    /*if (localStorage.getItem('currentUser')) {
      // logged in so return true
      return true;
    } else {
      return false;
    }*/
    this._localStorageService.getItem('currentUser');
    if (!this.auth.userIsLoggedIn()) {
      return false;
    } else {
      return true;
    }
  }

  getUserId(): number {
    let localStorageUser = JSON.parse(this._localStorageService.getItem('currentUser'));
    if (this.isLoggedIn()) {
      return +localStorageUser['userId'];
    } else {
      return 0;
    }
  }

  getUserToken(): string {
    let localStorageUser = JSON.parse(this._localStorageService.getItem('currentUser'));
    console.log('localStorageUser', localStorageUser);
    if (this.isLoggedIn()) {
      return localStorageUser ? localStorageUser['token'] : 'tokenTest';
    } else {
      return null;
    }
  }

  public getUser(): Promise<any> {
    return new Promise((resolve, reject) => {
      const user = parse.Object.extend("User");
      let query = new parse.Query(user);

      query.equalTo("objectId", parse.User.current().id);
      query.find().then(
        user => {
          resolve(user);
        },
        error => {
          reject(error);
        }
      );
    });
  }

  public getAPIToken(companyPtr): Promise<any> {
    return new Promise((resolve, reject) => {
      const app = parse.Object.extend("APIToken");
      let query = new parse.Query(app);
      query.equalTo("companyPtr", companyPtr);
      query.first().then(
        token => {
          resolve(token);
        },
        error => {
          console.log(error);
          reject();
        }
      );
    });
  }

  public getAllUsers(): Promise<any> {
    return new Promise((resolve, reject) => {
      const user = parse.Object.extend("User");
      let query = new parse.Query(user);
      query.find().then(
        user => {
          resolve(user);
        },
        error => {
          reject(error);
        }
      );
    });
  }


  public setCompanyLogo(companyLogo, name): Promise<any> {
    return new Promise((resolve, reject) => {
      const company = parse.Object.extend("Company");
      let query = new parse.Query(company);

      query.equalTo("objectId", parse.User.current().get("companyPtr").id);
      query.first().then(
        theCompany => {
          if (companyLogo) {
            //TODO img size et set le name par defaut peut etre ex: img.size < 300000
            var parseFile = new parse.File(name, companyLogo);
            theCompany.set("logo", parseFile);
          }
          theCompany.save(null, {
            success: function (obj) {
              resolve(obj);
            },
            error: function (obj, error) {
              reject(error);
            }
          });
        },
        error => {
          reject(error);
        }
      );
    });
  }

  public saveUser(
    firstname,
    lastname,
    email,
    avatar,
    img,
    companyLogo
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      //console.log("enter in save User",  parse.User.current().id);
      const user = parse.Object.extend("User");
      let query = new parse.Query(user);
      let thisCpy = this;

      query.equalTo("objectId", parse.User.current().id);
      query.first().then(
        theUser => {
          theUser.set('firstname', firstname);

          theUser.set('lastname', lastname);
          theUser.set('email', email);
          if (img) {
            //TODO img size et set le name par defaut peut etre ex: img.size < 300000
            var parseFile = new parse.File(avatar, img);
            theUser.set("image", parseFile);
          }

          theUser.save(null, {
            success: function (obj) {
              if (companyLogo) {
                thisCpy.setCompanyLogo(companyLogo, 'logo.jpg');
              }
              resolve(obj);
            },
            error: function (obj, error) {
              alert('Error save: ' + error.code + ' ' + error.message);
              reject(error);
            }
          });
        },
        error => {
          //console.log("error", error);

          reject(error);
        }
      );
    });
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  /** Log a UserService message with the MessageService */
  private log(message: string) { }
}



// WEBPACK FOOTER //
// ./src/app/service/user.service.ts